/* Product page (modern layout): tabs + gallery arrows */

if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (evt) => {
            if (evt.key !== 'ArrowRight' && evt.key !== 'ArrowLeft') return;
            const step = evt.key === 'ArrowRight' ? 1 : -1;
            const next = (index + step + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus();
          });
        });
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
      }
    }
  );
}

(function () {
  function visibleThumbs(gallery) {
    return Array.from(gallery.querySelectorAll('.thumbnail-list__item')).filter(
      (item) => item.offsetParent !== null
    );
  }

  function go(gallery, step) {
    const items = visibleThumbs(gallery);
    if (items.length < 2) return;
    let current = items.findIndex((item) => item.querySelector('[aria-current="true"]'));
    if (current < 0) current = 0;
    const next = items[(current + step + items.length) % items.length];
    const button = next.querySelector('button');
    if (button) button.click();
  }

  function addArrows(gallery) {
    if (gallery.dataset.arrowsReady) return;
    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    if (!viewer || !gallery.querySelector('.thumbnail-list__item')) return;
    gallery.dataset.arrowsReady = 'true';

    [
      ['prev', -1, 'M15 18l-6-6 6-6'],
      ['next', 1, 'M9 18l6-6-6-6'],
    ].forEach(([name, step, path]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `gallery-arrow gallery-arrow--${name}`;
      button.setAttribute('aria-label', name === 'prev' ? 'Previous image' : 'Next image');
      button.innerHTML = `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${path}"/></svg>`;
      button.addEventListener('click', () => go(gallery, step));
      viewer.appendChild(button);
    });
  }

  function init() {
    document.querySelectorAll('.product--modern media-gallery').forEach(addArrows);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
